/* Path: assets/profit-calculator-tool.js */
(function () {
  'use strict';

  function formatMoney(num) {
    if (isNaN(num) || !isFinite(num)) num = 0;
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bottleCostEl = document.getElementById('pc-bottle-cost');
    var sellingPriceEl = document.getElementById('pc-selling-price');
    var bottlesSoldEl = document.getElementById('pc-bottles-sold');
    var drinksPerBottleEl = document.getElementById('pc-drinks-per-bottle');
    var calcBtn = document.getElementById('pc-calculate-btn');

    if (!bottleCostEl || !sellingPriceEl || !bottlesSoldEl) return;

    var drinksPerBottle = parseFloat(drinksPerBottleEl.textContent) || 125;
    var bottleCost = parseFloat(bottleCostEl.getAttribute('data-value')) || 0;

    function update() {
      var sellingPrice = parseFloat(sellingPriceEl.value) || 0;
      var bottlesSold = parseFloat(bottlesSoldEl.value) || 0;

      var costPerServing = bottleCost / drinksPerBottle;
      var profitPerServing = sellingPrice - costPerServing;
      var profitPerBottle = profitPerServing * drinksPerBottle;
      var monthlyProfit = profitPerBottle * bottlesSold;
      var yearlyProfit = monthlyProfit * 12;

      document.getElementById('pc-cost-per-serving').textContent = formatMoney(costPerServing);
      document.getElementById('pc-cost-per-serving-formula').textContent =
        formatMoney(bottleCost) + ' ÷ ' + drinksPerBottle + ' drinks';

      document.getElementById('pc-profit-per-serving').textContent = formatMoney(profitPerServing);
      document.getElementById('pc-profit-per-serving-formula').textContent =
        formatMoney(sellingPrice) + ' − ' + formatMoney(costPerServing);

      document.getElementById('pc-profit-per-bottle').textContent = formatMoney(profitPerBottle);
      document.getElementById('pc-profit-per-bottle-formula').textContent =
        formatMoney(profitPerServing) + ' × ' + drinksPerBottle;

      document.getElementById('pc-monthly-profit').textContent = formatMoney(monthlyProfit);
      document.getElementById('pc-monthly-profit-formula').textContent =
        formatMoney(profitPerServing) + ' × ' + drinksPerBottle + ' × ' + bottlesSold;

      document.getElementById('pc-yearly-profit').textContent = formatMoney(yearlyProfit);
      document.getElementById('pc-yearly-profit-formula').textContent =
        formatMoney(monthlyProfit) + ' × 12 months';

      document.getElementById('pc-yearly-label-suffix').textContent =
        '(' + bottlesSold + ' Bottles/Month)';

      var monthlyLabelSpan = document.querySelectorAll('.profit-calc__result-label span')[1];
      if (monthlyLabelSpan) monthlyLabelSpan.textContent = '(' + bottlesSold + ' Bottles)';

      document.getElementById('pc-results-subtext').textContent =
        'Based on selling ' + bottlesSold + ' bottles per month at ' + formatMoney(sellingPrice) + ' per drink.';
    }

    sellingPriceEl.addEventListener('input', update);
    bottlesSoldEl.addEventListener('input', update);
    if (calcBtn) calcBtn.addEventListener('click', update);

    update();
  });
})();
